export const CONCLUSION_TIME_ERRORS = Object.freeze({
  START_AFTER_END: 'O horário de conclusão não pode ser anterior ao horário de início.',
  START_EQUALS_END: 'O horário de conclusão não pode ser igual ao horário de início.',
});
